import { tv } from 'tailwind-variants';
import { cn } from '@/shared/utils';
import OpenNewTabIcon from '@/shared/assets/open-new-tab-icon.svg?react';
import { Button } from '@/shared/components/ui';

const openInNewTabButtonVariants = tv({
  slots: {
    button:
      'group flex items-center justify-center hover:bg-transparent-bg bg-transparent-bg transition-colors text-foreground shadow-none px-[0.8rem] py-[0.8rem]',
    icon: 'text-current group-hover:text-muted-foreground transition-colors size-[100%]',
  },
  variants: {
    size: {
      sm: { button: 'size-[1.8rem]' },
      md: { button: 'size-[2.4rem]' },
      lg: { button: 'size-[3.2rem]' },
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

type Props = {
  url: string;
  className?: string;
  buttonClassName?: string;
  iconClassName?: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'default' | 'ghost' | 'secondary';
};

export const OpenInNewTabButton = ({
  url,
  className,
  buttonClassName,
  iconClassName,
  variant = 'secondary',
  size = 'md',
}: Props) => {
  const handleClick = () => {
    window.open(url, '_blank');
  };

  const { button, icon } = openInNewTabButtonVariants({ size });

  return (
    <div className={className}>
      <Button
        variant={variant}
        onClick={handleClick}
        className={cn(button(), buttonClassName)}>
        <OpenNewTabIcon className={cn(icon(), iconClassName)} />
      </Button>
    </div>
  );
};
